import { useTranslation } from "react-i18next";
import { useSurveyLayout } from "../useSurveyLayout";
import {
    SurveyHasNoQuestions,
    SurveyLoading,
    SurveyMissing,
    SurveyNotActive,
} from "../SurveyStatus/SurveyStatuses";
import { Button, Separator } from "frontend-components";

export default function SurveyStart() {
    const { t } = useTranslation();
    const { startSurvey, survey, questions, isLoading, isPreview } = useSurveyLayout();

    if (isLoading) {
        return <SurveyLoading />;
    }

    if (!survey) {
        return <SurveyMissing />;
    }

    if (!isPreview && survey.status !== "ACTIVE") {
        return <SurveyNotActive />;
    }

    if (questions && questions.length === 0) {
        return <SurveyHasNoQuestions />;
    }

    // Set the title when the component mounts

    return (
        <div className="flex flex-col gap-10">
            <h1 className="text-2xl font-semibold">{survey.title}</h1>
            <Separator />
            {survey.description && <p className="whitespace-pre-wrap">{survey.description}</p>}

            <div className="flex justify-center">
                <Button
                    variant="fill"
                    size="submit"
                    className="p-5 shadow-md rounded-sm"
                    onClick={startSurvey}
                >
                    {t("surveyResponse.startSurvey")}
                </Button>
            </div>
        </div>
    );
}
